import { ReactNode } from 'react'
import { PlacesType } from 'react-tooltip'
import styled from 'styled-components'

import { colors } from '@/config/global-parameters'

import Circle from './CircleMesh/Circle'
import Popover from './Popover'

interface IInfoTooltip {
  className?: string
  message: ReactNode
  color?: string
  id: string
  place?: PlacesType
  width?: string
}

const InfoTooltip = ({
  className,
  color,
  id,
  message,
  place,
  width = 'fit-content',
}: IInfoTooltip) => (
  <Wrapper className={className}>
    <Popover
      anchor={
        <Icon>
          <Circle color={color} />
          <I>i</I>
        </Icon>
      }
      id={id}
      place={place}
    >
      <Content width={width}>{message}</Content>
    </Popover>
  </Wrapper>
)

export const Wrapper = styled.div`
  width: 16px;
  .react-tooltip-arrow {
    translate: 8px;
  }
`

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const I = styled.span`
  width: 100%;
  text-align: center;
  margin: -100%;
  color: ${colors.colorWhite};
  font-size: 9px;
  transform: translateY(1px);
`

const Content = styled.div<{ width: string }>`
  width: ${({ width }) => width};
`

export default InfoTooltip
